import React, { useState, useEffect } from 'react';

import { getArrFromLocalStorage, setArrToLocalStorage } from '@vlabs/monokit/shared/lib/localStorage';
import { NotificationOnIcon, NotificationOffIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NotificationStatus } from '../../Cell';
import st from './SharedFormStyles.module.sass';

export function UINotificationSubForm() {
  const { t } = useTranslation();

  const {
    notificationId,
    formType,
    watch,
    register,
    setValue,
    getValues,
  } = useFormContext();

  const $notification = getValues();

  const isEnable = watch('ui.enable');

  const [pausedNotificationArr, setPausedNotificationArr] = useState(getArrFromLocalStorage('pausedNotifications'));

  useEffect(() => {
    setArrToLocalStorage('pausedNotifications', pausedNotificationArr);
  }, [pausedNotificationArr]);

  const pausedNotification = pausedNotificationArr.find((n) => n.id === notificationId);

  const onPauseNotification = (notification, type, time) => {
    const id = notificationId;
    if (type === 'add') {
      setPausedNotificationArr((prev) => {
        if (prev.some((n) => n.id === id)) return prev;
        return [...prev, { id, time }];
      });
    } else if (type === 'delete') {
      if (localStorage.getItem('offUINotification')) localStorage.removeItem('offUINotification');
      setPausedNotificationArr((prev) => prev.filter((n) => n.id !== id));
    }
  };

  const changeUIEnable = () => {
    setValue('ui.enable', !isEnable, { shouldDirty: true });
    if (!isEnable === false && pausedNotification?.id === notificationId) {
      onPauseNotification(notificationId, 'delete');
    }
  };

  return (
    <div className={st.NotificationFormBlock}>
      <div className={st.Header}>
        <div className={st.HeaderTitle}>
          {isEnable
            ? <NotificationOnIcon className={st.NotificationIcon} />
            : <NotificationOffIcon className={st.NotificationIcon} />}
          <h6>{t('vlNotifier:ui.enable_short_label')}</h6>
        </div>
        <NotificationStatus value={{
          notification: $notification,
          pausedNotification,
          notificationId,
          isEnable,
          onClick: changeUIEnable,
          onPause: onPauseNotification,
        }}
        />
      </div>
      {isEnable && (
        <>
          <div className={st.Separator} />
          <div className={st.CheckboxContainer}>
            <Control.Checkbox
              defaultChecked={formType === 'events'}
              disabled={formType === 'events'}
              id="ui.recipients.sound"
              label={t('vlNotifier:targets.sound')}
              {...register('ui.recipients.sound')}
            />
            <Control.Checkbox
              defaultChecked={formType === 'events'}
              disabled={formType === 'events'}
              id="ui.recipients.popup"
              label={t('vlNotifier:targets.pop_up')}
              {...register('ui.recipients.popup')}
            />
          </div>
        </>
      )}
    </div>
  );
}
